// @ts-nocheck
import { Input } from "@shared/antd/input";
import { Button } from "@shared/antd/button";
import { Modal } from "@shared/antd/modal";
import { Icon } from "@shared/antd/icon";
import * as React from "react";
import { ChangeEvent } from "react";
import { FileDescriptor } from "../../../../cuba/entities/base/sys$FileDescriptor";
import { IReactionDisposer, observable, reaction } from "mobx";
import { observer } from "mobx-react";
import { getFileUrl } from "../../../util/util";
import { injectIntl, WrappedComponentProps } from "react-intl";
import { ColumnProps } from "antd/lib/table";
import { FileUpload } from "@cuba-platform/react";
import Notification from "../../../util/Notification/Notification";
import { TableAdaptive } from "../../../common";
import "./style.less";

export type AttachmentFileData = {
  file: FileDescriptor;
  comment: string;
  name?: string;
  author: string;
  date?: string;
  id?: string;
}

type Props = WrappedComponentProps & {
  items?: AttachmentFileData[];
  columns?: ColumnProps<AttachmentFileData>[];
  label?: string;
  setAttachment: (attachment: AttachmentFileData[]) => void;
  isForecast?: boolean;
  isNeedDelete?: boolean;
  isNeedComment?: boolean;
  keyComment?: string;
  isNeedCreate?: boolean;
  isNeedSelect?: boolean;
}

type State = {
  selectedRowKeys: string[];
  isVisible: boolean;
  attachments: AttachmentFileData[];
  uploadKey: number;
  comment: string;
  isError: boolean;
}

const MB_SIZE = 30;
export const renderFileLink = (text: any, row: AttachmentFileData, index: number) => {
  const fileUrl = getFileUrl(row.file.id);
  return (
    <a href={fileUrl} target="_blank">
      {row.file.name}
    </a>
  );
};

@observer
class AttachmentsComponent extends React.Component<Props, State> {
  @observable data = this.props.items;
  dataWatcher: IReactionDisposer;

  state: State = {
    selectedRowKeys: [],
    isVisible: false,
    attachments: [],
    comment: "",
    uploadKey: 0,
    isError: false,
  };

  messages = this.props.intl.messages;

  constructor(props: Props) {
    super(props);
    this.dataWatcher = reaction(r => this.props.items, (arg, r) => {
      this.data = arg;
    });
  }

  onSelectChange = (selectedRowKeys: string[]) => {
    this.setState({ selectedRowKeys });
  };

  handleChange = (info: any) => {
    if (this.state.attachments.length > 0) this.setState({ attachments: [] });
    const id: string = info && info.id;
    if (id) {
      const newAttachment: any = {
        file: { ...info },

      };
      this.setState({
        attachments: [...this.state.attachments, newAttachment],
      });
    }
  };

  handleCommentChange = (e: ChangeEvent<HTMLInputElement>) => {
    this.setState({ comment: e.target.value });
  };

  render() {
    const {
      columns = [
        {
          title: this.messages["file"],
          dataIndex: "file",
          render: renderFileLink,
        },
        {
          title: this.messages["author"],
          dataIndex: "author",
          key: "author",
        },
        {
          title: this.messages["comment"],
          dataIndex: "comment",
          key: "comment",
        },
        {
          title: this.messages["date"],
          dataIndex: "date",
          key: "date",
        },
      ],
      label,
      items,
      setAttachment,
    } = this.props;

    const { selectedRowKeys } = this.state;

    const rowSelection = {
      selectedRowKeys,
      onChange: this.onSelectChange,
    };

    const deleteItem = () => {
      if (!items) return;
      const filtered = items.filter(item => !selectedRowKeys.includes(item.file.id));

      setAttachment(filtered);
    };

    const handleCancel = () => {
      this.setState({ isError: false });
      this.setState({ isVisible: false });
    };

    const handleSave = () => {
      if (this.state.isError) {
        Notification.error({
          message: this.props.intl.formatMessage({ id: "check-file-size" }, { count: MB_SIZE }),
        });
        return;
      }
      const key = this.props.keyComment || "comment";
      const res = this.state.attachments.map(items => ({ ...items, [key]: this.state.comment }));
      setAttachment([...items, ...res]);
      this.setState({ uploadKey: this.state.uploadKey + 1 });
      this.setState({ comment: "" });
      this.setState({ attachments: [] });

      handleCancel();
    };

    const { isNeedDelete = true, isNeedCreate = true, isNeedComment = true, isNeedSelect = true } = this.props;

    const propsTable = (isNeedSelect)
      ? {
        rowKey: (record) => record?.file?.id,
        rowSelection: rowSelection,
      }
      : {};

    return (
      <div id={"container"} className={"w-full h-full"}>
        <label htmlFor={"container"}>{label}</label>
        <div className={"attachments-button-control margin"}>
          {isNeedCreate &&
            <button
              type={"button"}
              className={"attachments__button primary"}
              onClick={() => this.setState({ isVisible: true })}
              disabled={this.props.isForecast}
            >
              <Icon type={"plus"} />
              {this.props.intl.formatMessage({ id: "cubaReact.dataTable.listEditor.addItem" })}
            </button>
          }
          {isNeedDelete &&
            <button
              type={"button"}
              className={"attachments__button delete"}
              onClick={deleteItem}
              disabled={this.props.isForecast}
            >
              <Icon type={"delete"} />
              {this.props.intl.formatMessage({ id: "delete" })}
            </button>
          }
        </div>
        <TableAdaptive
          className={"learning-budget-persons__table"}
          bordered
          dataSource={this.data}
          columns={columns}
          {...propsTable}
          pagination={false}
          key="attachments-table"
          rowKey="id"
          isNeedMobile
          scroll={{ x: 900 }}
        />

        <Modal
          title={this.props.intl.formatMessage({ id: "cba.detail.file.name" })}
          visible={this.state.isVisible}
          onCancel={handleCancel}
          footer={[
            <Button key="cancel" onClick={handleCancel}>
              {this.props.intl.formatMessage({ id: "header.logout.cancel" })}
            </Button>,
            <Button key="save" type="primary" onClick={handleSave}>
              {this.props.intl.formatMessage({ id: "save" })}
            </Button>,
          ]}
        >
          <FileUpload
            key={this.state.uploadKey}
            uploadProps={{
              beforeUpload: (file) => {
                const maxSize = MB_SIZE * 1024 * 1024; // 30MB
                if (file.size > maxSize) {
                  Notification.error({
                    message: this.props.intl.formatMessage({ id: "check-file-size" }, { count: MB_SIZE }),
                  });
                  this.setState({ isError: true });
                  return false;
                }
                this.setState({ isError: false });
                return true;
              },
            }}
            onChange={this.handleChange}
          />
          {isNeedComment && this.state.attachments.map((attachment, index) => (
            <div style={{ display: "flex", flexDirection: "column", gap: "10px", marginTop: "10px" }} key={index}>
              <label>{this.props.intl.formatMessage({ id: "comments" })}</label>
              <Input
                type="text"
                placeholder={this.props.intl.formatMessage({ id: "placeholder.comment" })}
                value={this.state.comment || ""}
                onChange={this.handleCommentChange}
              />
            </div>
          ))}
        </Modal>
      </div>
    );
  }

  componentWillUnmount() {
    this.dataWatcher();
  }
}

export default injectIntl(AttachmentsComponent);
